import type { ProgramInterface } from "../../types/program.interface";
import type { UserProgram } from "../../types/userProgram.interface";
import { StartProgramButton } from "./StartProgramButton";

type Props = {
  program: ProgramInterface;
  userProgram?: UserProgram;
  setOpenEnroll: () => void;
};

export const Materials: React.FC<Props> = ({ program, userProgram, setOpenEnroll }) => {
  return (
    <div className="text-left mb-50 mt-15">
      <h2 className="mb-3 text-3xl font-light font-juana">Los descargables que necesitas</h2>
      <div className="text-md text-gray-700">
        Descarga los materiales necesarios y maximiza tus resultados. ¡Haz del éxito algo inevitable!
      </div>

      {!userProgram && <StartProgramButton setOpenEnroll={setOpenEnroll} />}

      <div className="mt-15">
        {program?.materials?.map((material, index) => (
          <div key={index} className="bg-white py-10 px-5 my-4 flex items-center shadow-md">
            <div className="flex-grow">
              <h3 className="text-2xl text-gray-500 font-juana">{material.name}</h3>
              <div className="text-base text-gray-600">{material.description}</div>
            </div>
            <div className="px-3">
              {!userProgram ? (
                <img
                  src="https://cache.beholos.com/img/fitness-pass-v2/global/lock-icon.svg"
                  alt="Cerró"
                />
              ) : (
                <a href={material.url} download={material.name} target="_blank" rel="noopener noreferrer">
                  <img
                    src="https://cache.beholos.com/img/fitness-pass-v2/global/icono_descarga_002.svg"
                    alt="Cargar"
                  />
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};